/*
      Handles page-link visibility in side-nav component
      and if page-component should be mounted given the app-environment
 */

// List of page-path that should not be visible in side-nav link and
// should NOT be mounted in prod app-environment
import lodash from 'lodash';
import { isEnvironmentProduction } from '../env/env';

const devOnlyPageURLPathList = [
   // APP: developer/temp
   '/temp',
   '/temp/base-table',
   // APP: admin
   '/admin/report/email',
   '/admin/job-manager/feed-management',
   // APP: job-feed
   // '/job-feed/job-reporting',
   // APP: SSA
   // '/syndicated-sponsored-ads/ad-manager',
   // '/syndicated-sponsored-ads/ad-manager',
   // '/syndicated-sponsored-ads/edit-sponsored-partner',
   // '/syndicated-sponsored-ads/pit-raw-data',
   // '/syndicated-sponsored-ads/reporting',
   // APP: SA
   // '/sponsored-ads/campaign-manager',
   // '/sponsored-ads/edit-advertiser',
   // '/sponsored-ads/edit-campaign',
   // '/sponsored-ads/keyword-search-tool',
   // '/sponsored-ads/publisher-report',
   // '/sponsored-ads/reporting',
   // '/sponsored-ads/traffic-quality-report',
];


// Returns TRUE/FALSE
//          Determines if page-link in side-nav is rendered, along with its descendants,
//          And if the pageComponent is mounted in the app-routing
const getIsPageReadyWithAppEnvByURLPath = (urlPath) => {
   if (
      !lodash.isString(urlPath)
      || urlPath === undefined
      || urlPath === null
   ) {
      throw new Error(`Argument must be a String.`);
   }

   let isReady = true;

   if (isEnvironmentProduction() && devOnlyPageURLPathList.includes(urlPath)) {
      isReady = false;
   }

   return isReady;
};

const getIsPageReadyWithAppEnvByPathList = (pathList) => {
   let isReady = true;

   if (isEnvironmentProduction() && pathList.every((pathItem) => devOnlyPageURLPathList.includes(pathItem))) {
      isReady = false;
   }

   return isReady;
};

// Path can be a list of string or a string
const getIsPageReadyWithAppEnvByPath = (path) => {
   if (
      !lodash.isString(path)
      && !(
         lodash.isArray(path)
      && path.every((pathItem) => lodash.isString(pathItem))
      )
   ) {
      throw new Error(`Argument must be a String OR array of string.`);
   }

   return lodash.isString(path) ? getIsPageReadyWithAppEnvByURLPath(path) : getIsPageReadyWithAppEnvByPathList(path);
};

export default getIsPageReadyWithAppEnvByPath;
